import { render, staticRenderFns } from "./DisbursementDetail.vue?vue&type=template&id=9d2e44c0"
import script from "./DisbursementDetail.vue?vue&type=script&lang=js"
export * from "./DisbursementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports